import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/list-alt': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M464 32c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48h-416c-26.5 0-48-21.5-48-48v-352c0-26.5 21.5-48 48-48h416zM458 432c3.3 0 6-2.7 6-6v-340c0-3.3-2.7-6-6-6h-404c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h404zM416 340v24c0 6.6-5.4 12-12 12h-200c-6.6 0-12-5.4-12-12v-24c0-6.6 5.4-12 12-12h200c6.6 0 12 5.4 12 12zM416 244v24c0 6.6-5.4 12-12 12h-200c-6.6 0-12-5.4-12-12v-24c0-6.6 5.4-12 12-12h200c6.6 0 12 5.4 12 12zM416 148v24c0 6.6-5.4 12-12 12h-200c-6.6 0-12-5.4-12-12v-24c0-6.6 5.4-12 12-12h200c6.6 0 12 5.4 12 12zM164 160c0 19.9-16.1 36-36 36s-36-16.1-36-36 16.1-36 36-36 36 16.1 36 36zM164 256c0 19.9-16.1 36-36 36s-36-16.1-36-36 16.1-36 36-36 36 16.1 36 36zM164 352c0 19.9-16.1 36-36 36s-36-16.1-36-36 16.1-36 36-36 36 16.1 36 36z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/list-alt.js
// module id = 1792
// module chunks = 0